import { Chip } from "@ir/ui";
import { getPromoStatusChipColor } from "../utils/promotionDisplay.utils";

interface PromoStatusBadgeProps {
  statusName: string;
  statusKey: string;
}

export const PromoStatusBadge = ({ statusName, statusKey }: PromoStatusBadgeProps) => (
  <Chip borderless size="small" color={getPromoStatusChipColor(statusKey)} label={statusName} />
);
